// Education program data for Tamil Nadu districts

export const educationPrograms = {
    nightSchool: {
        id: 'night-school',
        name: 'இரவு பள்ளி',
        nameEnglish: 'Night School',
        icon: '🌙',
        color: '#9b59b6',
        districts: [
            'madurai', 'chennai', 'coimbatore', 'tiruchirappalli', 'salem',
            'tirunelveli', 'erode', 'vellore', 'thoothukudi', 'dindigul',
            'thanjavur', 'kanyakumari', 'tiruvannamalai'
        ],
        count: 13
    },
    computerEducation: {
        id: 'computer-education',
        name: 'கணினி பயிற்சி முகாம்',
        nameEnglish: 'Computer Training Camp',
        icon: '💻',
        color: '#3498db',
        districts: [
            'chennai', 'kanchipuram', 'ranipet', 'villupuram', 
            'cuddalore', 'tiruvallur', 'chengalpattu'
        ],
        count: 7,
        totalCenters: 33,
        centersByDistrict: {
            chennai: 7,
            kanchipuram: 8,
            ranipet: 3,
            villupuram: 1,
            cuddalore: 1,
            tiruvallur: 12,
            chengalpattu: 1
        }
    },
    freeBooks: {
        id: 'free-books',
        name: 'கணினி பயிற்சி முகாம்',
        nameEnglish: 'Free Study Materials',
        icon: '📚',
        color: '#e74c3c',
        districts: [
            'madurai', 'chennai', 'coimbatore', 'tiruchirappalli', 'salem',
            'tirunelveli', 'erode', 'vellore', 'thoothukudi', 'dindigul',
            'thanjavur', 'kanyakumari', 'tiruvannamalai', 'virudhunagar',
            'karur', 'namakkal', 'theni', 'cuddalore', 'kanchipuram',
            'villupuram', 'ramanathapuram', 'sivaganga', 'krishnagiri',
            'dharmapuri', 'pudukkottai', 'tiruppur', 'nagapattinam',
            'ariyalur', 'perambalur', 'nilgiris'
        ],
        count: 30
    },
    tutoring: {
        id: 'tutoring',
        name: 'தேர்மையும் அனைத்து பிரசேத்',
        nameEnglish: 'Academic Tutoring',
        icon: '✏️',
        color: '#2ecc71',
        districts: [
            'madurai', 'chennai', 'coimbatore', 'tiruchirappalli', 'salem',
            'tirunelveli', 'erode', 'vellore', 'thoothukudi', 'dindigul',
            'thanjavur', 'kanyakumari', 'tiruvannamalai', 'virudhunagar',
            'karur', 'namakkal', 'theni', 'cuddalore', 'kanchipuram',
            'villupuram', 'ramanathapuram', 'sivaganga', 'krishnagiri',
            'dharmapuri', 'pudukkottai', 'tiruppur', 'nagapattinam',
            'ariyalur', 'perambalur', 'nilgiris', 'tiruvarur', 'tiruvallur',
            'ranipet', 'tirupattur', 'chengalpattu', 'tenkasi', 'kallakurichi',
            'mayiladuthurai'
        ],
        count: 38
    },
    scholarships: {
        id: 'scholarships',
        name: 'புலி பாளம்ப்பார்ச்கள்',
        nameEnglish: 'Scholarship Program',
        icon: '🎓',
        color: '#f39c12',
        districts: [
            'madurai', 'chennai', 'coimbatore', 'tiruchirappalli', 'salem',
            'tirunelveli', 'erode', 'vellore', 'thoothukudi', 'dindigul',
            'thanjavur', 'kanyakumari', 'tiruvannamalai'
        ],
        count: 13
    },
    valueEducation: {
        id: 'value-education',
        name: 'தேர்மையும் அலைப்பங்கள்',
        nameEnglish: 'Value-Based Education',
        icon: '⭐',
        color: '#16a085',
        districts: [
            'madurai', 'chennai', 'coimbatore', 'tiruchirappalli', 'salem',
            'tirunelveli', 'erode', 'vellore', 'thoothukudi', 'dindigul',
            'thanjavur', 'kanyakumari', 'tiruvannamalai', 'virudhunagar',
            'karur', 'namakkal', 'theni', 'cuddalore', 'kanchipuram',
            'villupuram', 'ramanathapuram', 'sivaganga', 'krishnagiri',
            'dharmapuri', 'pudukkottai', 'tiruppur', 'nagapattinam',
            'ariyalur', 'perambalur', 'nilgiris', 'tiruvarur', 'tiruvallur',
            'ranipet', 'tirupattur', 'chengalpattu', 'tenkasi', 'kallakurichi',
            'mayiladuthurai'
        ],
        count: 38
    }
};

// District-specific data
export const districtDetails = {
    madurai: {
        id: 'madurai',
        name: 'Madurai',
        tamilName: 'மதுரை',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'We run evening classes for children who work during the day, providing them with quality education and a safe learning environment.',
                studentsEnrolled: 120,
                volunteers: 15,
                location: 'Perungudi, Madurai',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science', 'Social Studies'],
                achievements: [
                    '90% attendance rate',
                    '85% students improved grades',
                    'Free books and materials provided'
                ],
                images: [
                    '/images/programs/madurai-night-school-1.jpg',
                    '/images/programs/madurai-night-school-2.jpg',
                    '/images/programs/madurai-night-school-3.jpg'
                ],
                contact: {
                    coordinator: 'Rajesh Kumar',
                    phone: '+91 98765 43210',
                    email: 'madurai@nid.org'
                }
            },
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Basic computer literacy program teaching essential digital skills to underprivileged students.',
                studentsEnrolled: 80,
                volunteers: 8,
                location: 'Anna Nagar, Madurai',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Basic Computer', 'MS Office', 'Internet Basics', 'Typing'],
                achievements: [
                    '80 students trained',
                    'Free certificates provided',
                    'Job placement assistance'
                ],
                images: [
                    '/images/programs/madurai-computer-1.jpg',
                    '/images/programs/madurai-computer-2.jpg'
                ],
                contact: {
                    coordinator: 'Priya Devi',
                    phone: '+91 98765 43211',
                    email: 'madurai@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 200,
            totalVolunteers: 23,
            totalCenters: 2,
            yearsActive: 8
        }
    },
    chennai: {
        id: 'chennai',
        name: 'Chennai',
        tamilName: 'சென்னை',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'We conduct 7 computer training camps across Chennai, providing free computer education and digital literacy skills to underprivileged students.',
                studentsEnrolled: 210,
                volunteers: 28,
                location: 'Multiple locations: Perambur, Anna Nagar, T. Nagar, Adyar, Tambaram, Ambattur, Velachery',
                timings: 'Monday-Saturday 4:00 PM - 7:00 PM',
                subjects: ['Basic Computer Operations', 'MS Office (Word, Excel, PowerPoint)', 'Internet & Email', 'Typing Skills', 'Coding Basics'],
                achievements: [
                    '7 active computer training centers',
                    '210+ students trained annually',
                    'Free certificates and study materials',
                    'Placement assistance provided',
                    '95% course completion rate'
                ],
                images: [
                    '/images/programs/chennai-computer-1.jpg',
                    '/images/programs/chennai-computer-2.jpg',
                    '/images/programs/chennai-computer-3.jpg'
                ],
                contact: {
                    coordinator: 'Selvam Murugan',
                    phone: '+91 98765 43220',
                    email: 'chennai@nid.org'
                },
                centersCount: 7
            }
        ],
        stats: {
            totalStudents: 210,
            totalVolunteers: 28,
            totalCenters: 7,
            yearsActive: 10
        }
    },
    coimbatore: {
        id: 'coimbatore',
        name: 'Coimbatore',
        tamilName: 'கோயம்புத்தூர்',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Quality evening education for children from weaving communities.',
                studentsEnrolled: 90,
                volunteers: 12,
                location: 'Gandhipuram, Coimbatore',
                timings: '5:30 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '90 students enrolled',
                    'Focus on practical skills',
                    'Parent engagement programs'
                ],
                images: [
                    '/images/programs/coimbatore-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Lakshmi Narayanan',
                    phone: '+91 98765 43230',
                    email: 'coimbatore@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 90,
            totalVolunteers: 12,
            totalCenters: 1,
            yearsActive: 6
        }
    },
    tiruchirappalli: {
        id: 'tiruchirappalli',
        name: 'Tiruchirappalli',
        tamilName: 'திருச்சிராப்பள்ளி',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Providing quality education to underprivileged children in the evening hours.',
                studentsEnrolled: 85,
                volunteers: 10,
                location: 'Srirangam, Tiruchirappalli',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '85 students enrolled',
                    'High pass percentage',
                    'Community support programs'
                ],
                images: [
                    '/images/programs/trichy-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Kumar Vel',
                    phone: '+91 98765 43240',
                    email: 'trichy@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 85,
            totalVolunteers: 10,
            totalCenters: 1,
            yearsActive: 7
        }
    },
    salem: {
        id: 'salem',
        name: 'Salem',
        tamilName: 'சேலம்',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening classes for working children and students from low-income families.',
                studentsEnrolled: 75,
                volunteers: 9,
                location: 'Suramangalam, Salem',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science', 'Social Studies'],
                achievements: [
                    '75 students benefit',
                    'Free study materials',
                    'Regular assessments'
                ],
                images: [
                    '/images/programs/salem-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Anitha Devi',
                    phone: '+91 98765 43250',
                    email: 'salem@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 75,
            totalVolunteers: 9,
            totalCenters: 1,
            yearsActive: 5
        }
    },
    tirunelveli: {
        id: 'tirunelveli',
        name: 'Tirunelveli',
        tamilName: 'திருநெல்வேலி',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Empowering young minds through quality evening education programs.',
                studentsEnrolled: 70,
                volunteers: 8,
                location: 'Palayamkottai, Tirunelveli',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '70 students enrolled',
                    'Strong community involvement',
                    'Regular parent-teacher meetings'
                ],
                images: [
                    '/images/programs/tirunelveli-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Murugan Raj',
                    phone: '+91 98765 43260',
                    email: 'tirunelveli@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 70,
            totalVolunteers: 8,
            totalCenters: 1,
            yearsActive: 6
        }
    },
    erode: {
        id: 'erode',
        name: 'Erode',
        tamilName: 'ஈரோடு',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening education program for children from agricultural families.',
                studentsEnrolled: 65,
                volunteers: 8,
                location: 'Sathy Road, Erode',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '65 students enrolled',
                    'Focus on rural education',
                    'Agricultural awareness programs'
                ],
                images: [
                    '/images/programs/erode-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Senthil Kumar',
                    phone: '+91 98765 43270',
                    email: 'erode@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 65,
            totalVolunteers: 8,
            totalCenters: 1,
            yearsActive: 5
        }
    },
    vellore: {
        id: 'vellore',
        name: 'Vellore',
        tamilName: 'வேலூர்',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Quality evening education for underprivileged students.',
                studentsEnrolled: 80,
                volunteers: 10,
                location: 'Katpadi, Vellore',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science', 'Computer Basics'],
                achievements: [
                    '80 students enrolled',
                    'Modern teaching methods',
                    'Career guidance programs'
                ],
                images: [
                    '/images/programs/vellore-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Ramesh Babu',
                    phone: '+91 98765 43280',
                    email: 'vellore@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 80,
            totalVolunteers: 10,
            totalCenters: 1,
            yearsActive: 6
        }
    },
    thoothukudi: {
        id: 'thoothukudi',
        name: 'Thoothukudi',
        tamilName: 'தூத்துக்குடி',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening classes for coastal community children.',
                studentsEnrolled: 60,
                volunteers: 7,
                location: 'Millerpuram, Thoothukudi',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '60 students benefit',
                    'Focus on fishing community',
                    'Environmental education'
                ],
                images: [
                    '/images/programs/thoothukudi-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Francis Xavier',
                    phone: '+91 98765 43290',
                    email: 'thoothukudi@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 60,
            totalVolunteers: 7,
            totalCenters: 1,
            yearsActive: 4
        }
    },
    dindigul: {
        id: 'dindigul',
        name: 'Dindigul',
        tamilName: 'திண்டுக்கல்',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Providing education opportunities to children in rural areas.',
                studentsEnrolled: 55,
                volunteers: 7,
                location: 'Palani Road, Dindigul',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '55 students enrolled',
                    'Strong volunteer support',
                    'Nutritious snacks provided'
                ],
                images: [
                    '/images/programs/dindigul-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Meena Kumari',
                    phone: '+91 98765 43300',
                    email: 'dindigul@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 55,
            totalVolunteers: 7,
            totalCenters: 1,
            yearsActive: 5
        }
    },
    thanjavur: {
        id: 'thanjavur',
        name: 'Thanjavur',
        tamilName: 'தஞ்சாவூர்',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening education center in the rice bowl of Tamil Nadu.',
                studentsEnrolled: 70,
                volunteers: 9,
                location: 'Medical College Road, Thanjavur',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science', 'Cultural Arts'],
                achievements: [
                    '70 students enrolled',
                    'Cultural heritage programs',
                    'Music and arts education'
                ],
                images: [
                    '/images/programs/thanjavur-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Bharathi Sundaram',
                    phone: '+91 98765 43310',
                    email: 'thanjavur@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 70,
            totalVolunteers: 9,
            totalCenters: 1,
            yearsActive: 7
        }
    },
    kanyakumari: {
        id: 'kanyakumari',
        name: 'Kanyakumari',
        tamilName: 'கன்னியாகுமரி',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening classes at the southern tip of India.',
                studentsEnrolled: 50,
                volunteers: 6,
                location: 'Nagercoil, Kanyakumari',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science'],
                achievements: [
                    '50 students enrolled',
                    'Multilingual support',
                    'Focus on coastal communities'
                ],
                images: [
                    '/images/programs/kanyakumari-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Thomas Joseph',
                    phone: '+91 98765 43320',
                    email: 'kanyakumari@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 50,
            totalVolunteers: 6,
            totalCenters: 1,
            yearsActive: 4
        }
    },
    tiruvannamalai: {
        id: 'tiruvannamalai',
        name: 'Tiruvannamalai',
        tamilName: 'திருவண்ணாமலை',
        programs: [
            {
                id: 'night-school',
                name: 'Night School',
                tamilName: 'இரவு பள்ளி',
                description: 'Evening education program in the temple city.',
                studentsEnrolled: 65,
                volunteers: 8,
                location: 'Kilpennathur, Tiruvannamalai',
                timings: '6:00 PM - 8:00 PM',
                subjects: ['Tamil', 'English', 'Mathematics', 'Science', 'Moral Education'],
                achievements: [
                    '65 students enrolled',
                    'Character building programs',
                    'Spiritual education'
                ],
                images: [
                    '/images/programs/tiruvannamalai-night-school-1.jpg'
                ],
                contact: {
                    coordinator: 'Ganesan Pillai',
                    phone: '+91 98765 43330',
                    email: 'tiruvannamalai@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 65,
            totalVolunteers: 8,
            totalCenters: 1,
            yearsActive: 5
        }
    },
    virudhunagar: {
        id: 'virudhunagar',
        name: 'Virudhunagar',
        tamilName: 'விருதுநகர்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Computer literacy program for rural students.',
                studentsEnrolled: 45,
                volunteers: 5,
                location: 'Sivakasi Road, Virudhunagar',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Basic Computer', 'MS Office', 'Internet', 'Typing'],
                achievements: [
                    '45 students trained',
                    'Free certificates',
                    'Digital literacy programs'
                ],
                images: [
                    '/images/programs/virudhunagar-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Vijayan Natarajan',
                    phone: '+91 98765 43340',
                    email: 'virudhunagar@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 45,
            totalVolunteers: 5,
            totalCenters: 1,
            yearsActive: 3
        }
    },
    karur: {
        id: 'karur',
        name: 'Karur',
        tamilName: 'கரூர்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Teaching computer skills to textile industry workers\' children.',
                studentsEnrolled: 40,
                volunteers: 5,
                location: 'Thanthoni Road, Karur',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Basic Computer', 'MS Office', 'Internet Basics'],
                achievements: [
                    '40 students trained',
                    'Industry partnership',
                    'Job skill development'
                ],
                images: [
                    '/images/programs/karur-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Karthik Raja',
                    phone: '+91 98765 43350',
                    email: 'karur@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 40,
            totalVolunteers: 5,
            totalCenters: 1,
            yearsActive: 3
        }
    },
    tiruvallur: {
        id: 'tiruvallur',
        name: 'Tiruvallur',
        tamilName: 'திருவள்ளூர்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'We conduct 12 computer training camps across Tiruvallur district, providing comprehensive computer education and digital skills to rural students.',
                studentsEnrolled: 360,
                volunteers: 48,
                location: 'Multiple locations: Poonamallee, Avadi, Tiruvallur Town, Gummidipoondi, Uthukottai, Pallipattu, Tiruttani, Ponneri, and 4 more centers',
                timings: 'Monday-Saturday 4:00 PM - 7:00 PM',
                subjects: ['Basic Computer Operations', 'MS Office Suite', 'Internet & Email', 'Typing', 'Digital Literacy'],
                achievements: [
                    '12 active computer training centers',
                    '360+ students trained annually',
                    'Largest computer camp network in the region',
                    'Free certificates and study materials',
                    'Job placement support'
                ],
                images: [
                    '/images/programs/tiruvallur-computer-1.jpg',
                    '/images/programs/tiruvallur-computer-2.jpg',
                    '/images/programs/tiruvallur-computer-3.jpg'
                ],
                contact: {
                    coordinator: 'Saravanan Kumar',
                    phone: '+91 98765 43360',
                    email: 'tiruvallur@nid.org'
                },
                centersCount: 12
            }
        ],
        stats: {
            totalStudents: 360,
            totalVolunteers: 48,
            totalCenters: 12,
            yearsActive: 4
        }
    },
    namakkal: {
        id: 'namakkal',
        name: 'Namakkal',
        tamilName: 'நாமக்கல்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training',
                tamilName: 'கணினி பயிற்சி',
                description: 'Basic computer education for school students.',
                studentsEnrolled: 50,
                volunteers: 6,
                location: 'Tiruchengode Road, Namakkal',
                timings: 'Monday-Saturday 3:30 PM - 5:30 PM',
                subjects: ['Computer Basics', 'MS Office', 'Internet'],
                achievements: [
                    '50 students trained',
                    'Free certifications',
                    'Industry exposure'
                ],
                images: [
                    '/images/programs/namakkal-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Divya Priya',
                    phone: '+91 98765 43370',
                    email: 'namakkal@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 50,
            totalVolunteers: 6,
            totalCenters: 1,
            yearsActive: 4
        }
    },
    theni: {
        id: 'theni',
        name: 'Theni',
        tamilName: 'தேனி',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training',
                tamilName: 'கணினி பயிற்சி',
                description: 'Digital education for hill area students.',
                studentsEnrolled: 35,
                volunteers: 4,
                location: 'Periyakulam, Theni',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Computer Basics', 'Typing', 'Internet Basics'],
                achievements: [
                    '35 students trained',
                    'Focus on hill communities',
                    'Agricultural tech awareness'
                ],
                images: [
                    '/images/programs/theni-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Murugesan Raj',
                    phone: '+91 98765 43380',
                    email: 'theni@nid.org'
                }
            }
        ],
        stats: {
            totalStudents: 35,
            totalVolunteers: 4,
            totalCenters: 1,
            yearsActive: 3
        }
    },
    cuddalore: {
        id: 'cuddalore',
        name: 'Cuddalore',
        tamilName: 'கடலூர்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Computer training camp providing digital literacy to students from coastal communities.',
                studentsEnrolled: 30,
                volunteers: 4,
                location: 'Chidambaram Road, Cuddalore',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Computer Basics', 'MS Office', 'Internet & Email', 'Typing'],
                achievements: [
                    '1 active computer training center',
                    '30+ students trained',
                    'Focus on coastal area students',
                    'Free certificates provided',
                    'Digital skills for employment'
                ],
                images: [
                    '/images/programs/cuddalore-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Velu Mudaliar',
                    phone: '+91 98765 43390',
                    email: 'cuddalore@nid.org'
                },
                centersCount: 1
            }
        ],
        stats: {
            totalStudents: 30,
            totalVolunteers: 4,
            totalCenters: 1,
            yearsActive: 3
        }
    },
    kanchipuram: {
        id: 'kanchipuram',
        name: 'Kanchipuram',
        tamilName: 'காஞ்சிபுரம்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'We conduct 8 computer training camps across Kanchipuram district, empowering students from weaving communities with digital skills.',
                studentsEnrolled: 240,
                volunteers: 32,
                location: 'Multiple locations: Kanchipuram Town, Chengalpattu Road, Uthiramerur, Walajabad, Sriperumbudur, and 3 more centers',
                timings: 'Monday-Saturday 4:00 PM - 7:00 PM',
                subjects: ['Basic Computer Operations', 'MS Office', 'Internet & Email', 'Typing Skills', 'Digital Design Basics'],
                achievements: [
                    '8 active computer training centers',
                    '240+ students trained annually',
                    'Focus on silk weaving community',
                    'Free certificates and materials',
                    'Employment skill development'
                ],
                images: [
                    '/images/programs/kanchipuram-computer-1.jpg',
                    '/images/programs/kanchipuram-computer-2.jpg'
                ],
                contact: {
                    coordinator: 'Muthu Lakshmi',
                    phone: '+91 98765 43400',
                    email: 'kanchipuram@nid.org'
                },
                centersCount: 8
            }
        ],
        stats: {
            totalStudents: 240,
            totalVolunteers: 32,
            totalCenters: 8,
            yearsActive: 6
        }
    },
    ranipet: {
        id: 'ranipet',
        name: 'Ranipet',
        tamilName: 'ராணிப்பேட்டை',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'We conduct 3 computer training camps in Ranipet district, providing computer education to students from industrial area communities.',
                studentsEnrolled: 90,
                volunteers: 12,
                location: 'Multiple locations: Ranipet Town, Walajapet, Arcot',
                timings: 'Monday-Saturday 4:00 PM - 6:30 PM',
                subjects: ['Computer Basics', 'MS Office', 'Internet', 'Typing', 'Email Communication'],
                achievements: [
                    '3 active computer training centers',
                    '90+ students trained annually',
                    'Industrial area focus',
                    'Free study materials',
                    'Career guidance provided'
                ],
                images: [
                    '/images/programs/ranipet-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Ganesh Babu',
                    phone: '+91 98765 43410',
                    email: 'ranipet@nid.org'
                },
                centersCount: 3
            }
        ],
        stats: {
            totalStudents: 90,
            totalVolunteers: 12,
            totalCenters: 3,
            yearsActive: 4
        }
    },
    villupuram: {
        id: 'villupuram',
        name: 'Villupuram',
        tamilName: 'விழுப்புரம்',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Computer training camp serving students from rural areas of Villupuram district.',
                studentsEnrolled: 30,
                volunteers: 4,
                location: 'Villupuram Town',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Computer Fundamentals', 'MS Office', 'Internet Basics', 'Typing'],
                achievements: [
                    '1 active computer training center',
                    '30+ students trained',
                    'Rural area focus',
                    'Free certificates',
                    'Basic digital literacy'
                ],
                images: [
                    '/images/programs/villupuram-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Pandi Rajan',
                    phone: '+91 98765 43420',
                    email: 'villupuram@nid.org'
                },
                centersCount: 1
            }
        ],
        stats: {
            totalStudents: 30,
            totalVolunteers: 4,
            totalCenters: 1,
            yearsActive: 2
        }
    },
    chengalpattu: {
        id: 'chengalpattu',
        name: 'Chengalpattu',
        tamilName: 'செங்கல்பட்டு',
        programs: [
            {
                id: 'computer-education',
                name: 'Computer Training Camp',
                tamilName: 'கணினி பயிற்சி முகாம்',
                description: 'Computer training camp providing essential digital skills to students in Chengalpattu.',
                studentsEnrolled: 30,
                volunteers: 4,
                location: 'Chengalpattu Town',
                timings: 'Monday-Saturday 4:00 PM - 6:00 PM',
                subjects: ['Computer Basics', 'MS Office', 'Internet', 'Typing', 'Email'],
                achievements: [
                    '1 active computer training center',
                    '30+ students enrolled',
                    'Regular skill assessments',
                    'Free study materials',
                    'Certificate program'
                ],
                images: [
                    '/images/programs/chengalpattu-computer-1.jpg'
                ],
                contact: {
                    coordinator: 'Karthik Sundaram',
                    phone: '+91 98765 43430',
                    email: 'chengalpattu@nid.org'
                },
                centersCount: 1
            }
        ],
        stats: {
            totalStudents: 30,
            totalVolunteers: 4,
            totalCenters: 1,
            yearsActive: 2
        }
    }
    // Add more districts as needed
};

// Helper function to get programs by district
export const getProgramsByDistrict = (districtId) => {
    return districtDetails[districtId] || null;
};

// Helper function to get districts by program
export const getDistrictsByProgram = (programId) => {
    const program = Object.values(educationPrograms).find(p => p.id === programId);
    return program ? program.districts : [];
};
